import store from '@/store';

export default {
  printer(data, printerServerAddress) {
    return fetch(`https://${printerServerAddress}`, {
      credentials: 'omit',
      headers: { accept: 'application/json, text/plain, */*', 'content-type': 'application/json', 'sec-fetch-dest': 'empty' },
      referrerPolicy: 'no-referrer-when-downgrade',
      body: JSON.stringify(data),
      method: 'POST',
      mode: 'no-cors',
    }).catch((e) => {
      if (e.message.search('Failed to fetch') !== 1) {
        store.commit('setMessageModal', 'Switch to the newly opened tab. Click "Advanced" then continue to click "Proceed to xxx.xxx.xxx.xxx (unsafe)". Finally, Reprint');
        setTimeout(() => {
          window.open(`https://${printerServerAddress}`, '_blank');
        }, 2000);
      }
    });
  },
};